import { track } from '../utils/tracking';

const MAPBOX_TOKEN = 'pk.eyJ1IjoicGl4ZWx0ZXIiLCJhIjoiY21hazBmMW54MHp3dDJqc2pnNDZva3F0cyJ9.-nQ_W1dmjwFBlG71a6Tykw';

class ZipCoverage extends HTMLElement {
  constructor() {
    super();
    this.zipField = this.querySelector('[data-zip-field]');
    this.submitBtn = this.querySelector('[data-submit-button]');
    this.resetBtn = this.querySelector('[data-reset-button]');
    this.errorMessage = this.querySelector('[data-error-message]');
    this.form = this.querySelector('[data-form]');
    this.formStep = this.querySelector('[data-form-step]');
    this.resultsStep = this.querySelector('[data-results-step]');
    this.mapImg = this.querySelector('[data-map-img]');
    this.zipCode = this.querySelector('[data-zip-code]');
    this.coverageTitle = this.querySelector('[data-coverage-title]');
    this.signalIcons = this.querySelectorAll('[data-signal-icon]');
    this.singalTitles = this.querySelectorAll('[data-signal-title]');
    this.resultsSuccess = this.querySelector('[data-results-success]');
    this.resultsFailed = this.querySelector('[data-results-failed]');

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.resetBtn.addEventListener('click', this.reset.bind(this));
  }

  statusMap = {
    '4G EXCELLENT': 'excellent',
    '4G GOOD': 'good',
    '4G FAIR': 'fair',
    'NO COVERAGE': 'no',
  }

  updateCoverageTitle(coverage, zip) {
    const status = this.statusMap[coverage];

    this.zipCode.textContent = zip;

    // Update signal info
    this.singalTitles.forEach(title => {
      title.classList.add('hidden');
    });
    [...this.singalTitles].find(title => title.dataset.signalTitle === status).classList.remove('hidden');

    // Update UI
    const isSuccess = status !== 'no';
    this.resultsSuccess.classList.toggle('hidden', !isSuccess);
    this.resultsFailed.classList.toggle('hidden', isSuccess);

    track(`zip_coverage_${isSuccess ? 'success' : 'failed'}`);

    // Update signal icon
    this.signalIcons.forEach(icon => {
      icon.classList.add('hidden');
    });
    [...this.signalIcons].find(icon => icon.dataset.signalIcon === status).classList.remove('hidden'); 
  }

  async updateMap(zip) {
    const geoResponse = await fetch(`https://api.mapbox.com/search/geocode/v6/forward?postcode=${zip}&country=us,pr&access_token=${MAPBOX_TOKEN}&limit=1`);
    const geoData = await geoResponse.json();
    const bbox = geoData.features?.[0]?.properties.bbox;

    if (!bbox) {
      return null;
    }

    const mapUrl = `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/[${bbox[0]},${bbox[1]},${bbox[2]},${bbox[3]}]/400x250?access_token=${MAPBOX_TOKEN}`;
    
    this.mapImg.src = mapUrl;
    this.mapImg.classList.remove('hidden');
  }

  async fetchCoverage(zip) {
    const response = await fetch('https://prepaid-api.aqsatel.com/api/Pre-paid/ServiceAvailability', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        companyId: 'UNITYCRM0021',
        zipCode: zip,
        source: 'WebBrowser',
        userID: '3',
      }),
    });

    const data = await response.json();
    
    if (data.Status !== true) {
      console.error(data);
      throw new Error('Failed to fetch coverage');
    }

    const coverage = data.data[0].overallServiceStrength;
    return coverage;
  }

  showResults() {
    this.formStep.classList.add('hidden');
    this.resultsStep.classList.remove('hidden');
  }

  reset() {
    this.resultsStep.classList.add('hidden');
    this.formStep.classList.remove('hidden');
    this.zipField.value = '';
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.errorMessage.classList.add('hidden');
    this.submitBtn.classList.add('loading');

    try {
      const zip = this.zipField.value;
      const promises = [this.fetchCoverage(zip), this.updateMap(zip)];
      const [coverage] = await Promise.all(promises);
      this.updateCoverageTitle(coverage, zip);
      this.showResults();
    } catch (error) {
      console.error(error);
      this.errorMessage.classList.remove('hidden');
    } finally {
      this.submitBtn.classList.remove('loading');
    }
  }
}

customElements.define('zip-coverage', ZipCoverage);
